/**
 * TV週間 5段階ラベル（バックエンド境界と同一）
 */

export const TV_FIVE_LEVEL_LABELS = {
  1: '少なめ',
  2: 'やや少',
  3: '普通',
  4: 'やや多',
  5: '多め',
};

export const TV_WEEKLY_PROFILE_ALLOWLIST = ['legacy', 'tv_weekly_v1'];

/**
 * 少なめ1–5 / やや少なめ6–8 / 普通9–12 /
 * やや多め13–15 / 多め16–20
 */
export function fiveLevelFromDailyMean(dailyMean) {
  if (dailyMean == null || Number.isNaN(Number(dailyMean))) return null;
  const v = Number(dailyMean);
  if (v < 6) return 1;
  if (v < 9) return 2;
  if (v < 13) return 3;
  if (v < 16) return 4;
  return 5;
}

export function normalizeTvWeeklyProfile(raw, { isProduction = false } = {}) {
  if (isProduction) {
    return 'tv_weekly_v1';
  }
  const v = String(raw || 'tv_weekly_v1').trim();
  if (!TV_WEEKLY_PROFILE_ALLOWLIST.includes(v)) {
    return null;
  }
  return v;
}

export function getTvDemoDataSource() {
  const raw = String(import.meta.env.VITE_TV_DEMO_DATA_SOURCE || 'mock').toLowerCase();
  return raw === 'live' ? 'live' : 'mock';
}
